import { render, staticRenderFns } from "./dailynews.vue?vue&type=template&id=1768615e&scoped=true&"
import script from "./dailynews.vue?vue&type=script&lang=js&"
export * from "./dailynews.vue?vue&type=script&lang=js&"
import style0 from "./dailynews.vue?vue&type=style&index=0&id=1768615e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1768615e",
  null
  
)

component.options.__file = "dailynews.vue"
export default component.exports